import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VacanciesKpiCfgService } from 'src/app/vacancies/services/vacanciesKpiCfg.service';
import { VacanciesDetailServiceData } from '../models/vacancie-detail.model';

@Injectable({
  providedIn: 'root'
})
export class VacancieService {

  constructor(private serviceCfg: VacanciesKpiCfgService, private httpClient: HttpClient) { }

  /**
   * Consulta las vacantes
   * @returns Modelo de respuesta
   */
  getAll(): Observable<VacanciesDetailServiceData> {
    let url = this.serviceCfg.getCfg().vacancies.detailEndpointPattern.format("0");
    return this.httpClient.get<VacanciesDetailServiceData>(url);
  }
}
